import {observable, action, runInAction} from 'mobx'
import {IAnswer} from '../types/answer'

import {getAnswers, upsertAnswer} from './api/answer'
import {NotificationStore} from './NotificationStore'

export class AnswerStore {
  @observable
  answers: IAnswer[] = []
  @observable
  editingAnswer = false

  notifications: NotificationStore

  constructor(notifications: NotificationStore) {
    this.notifications = notifications
  }
  @action
  async upsertAnswer(answer: IAnswer, electionId: number, candidateId: number | string): Promise<any> {
    try {
      const newAnswer = await upsertAnswer(electionId, candidateId, answer)
      runInAction(() => {
        const oldAnswer = this.answers.find(a => a.question_id === newAnswer.question_id)
        if (oldAnswer) {
          this.answers = this.answers.map(a => (a.question_id === newAnswer.question_id ? newAnswer : a))
        } else {
          this.answers = [...this.answers, newAnswer]
        }
      })
    } catch (error) {
      runInAction(() => {
        this.notifications.showNotification({message: 'Virhe vastauksen tallentamisessa', type: 'error'})
      })
      throw error
    }
  }

  @action
  async fetchAnswers(electionId: number, candidateId: number): Promise<IAnswer[]> {
    this.answers = []
    try {
      const answers = await getAnswers(electionId, candidateId)
      this.setAnswers(answers)
    } catch (error) {
      throw new Error('Error fetching answers')
    }
    return this.answers
  }

  @action
  startEditing() {
    this.editingAnswer = true
  }

  @action
  finishEditing() {
    this.editingAnswer = false
  }

  @action
  setAnswers(answers: IAnswer[]) {
    this.answers = answers
  }
}
